module.exports = __webpack_public_path__ + "img/img_waiting.44b6acb3.png";